import axios from 'axios';

import { IModelESystemParameter } from '@/shared/model/model-e-system-parameter.model';

const baseApiUrl = 'api/model-e-system-parameters';

export default class ModelESystemSystemParameterService {
  public retrieve(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IModelESystemParameter): Promise<IModelESystemParameter> {
    return new Promise<IModelESystemParameter>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public reset(parameterId: number): Promise<IModelESystemParameter> {
    return new Promise<IModelESystemParameter>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/reset/${parameterId}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
